/**
 * Runs work after the next paint so interaction handlers can paint UI first.
 * Same callbacks still fire — only deferred by one frame (~16–50ms).
 * Safe for analytics: events/payloads unchanged.
 */
export function scheduleAfterPaint(task: () => void): void {
  if (typeof window === "undefined") {
    task();
    return;
  }

  requestAnimationFrame(() => {
    window.setTimeout(task, 0);
  });
}
